// 引入pako 压缩
import pako from "pako"
import { Base64 } from 'js-base64'

//  JSON 序列化处理
const JSONStringify = function(option) {
  return JSON.stringify(option,
    (key, val) => {
      // 处理函数丢失问题
      if (typeof val === 'function') {
        return `${val}`;
      }
      // 处理undefined丢失问题
      if (typeof val === 'undefined') {
        return 'undefined';
      }
      return val;
    },
    2
  )
};
const JSONParse = function(objStr) {
  return JSON.parse(objStr, (k, v) => {
    if (typeof v === 'string' && v.indexOf && v.indexOf('function') > -1) {
      // eval 可能在eslint中报错，需要加入下行注释
      // eslint-disable-next-line
      return eval(`(function(){return ${v}})()`);
    }
    return v;
  });
};

// 压缩和解压
const unzip = function(b64Data) {
  let strData = atob(b64Data);
    let charData = strData.split('').map(function (x) {
      return x.charCodeAt(0);
    });
    let binData = new Uint8Array(charData);
    let data = pako.ungzip(binData);

    // ↓切片处理数据，防止内存溢出报错↓
    let str = '';
    const chunk = 8 * 1024
    let i;
    for (i = 0; i < data.length / chunk; i++) {
      str += String.fromCharCode.apply(null, data.slice(i * chunk, (i + 1) * chunk));
    }
    str += String.fromCharCode.apply(null, data.slice(i * chunk));
    // ↑切片处理数据，防止内存溢出报错↑

    const unzipStr = Base64.decode(str);
  //   let result = ''

  //   // 对象或数组进行JSON转换
  //   try {
  //     result = JSON.parse(unzipStr)
  //   } catch (error) {
  //     if (/Unexpected token o in JSON at position 0/.test(error)) {
  //       // 如果没有转换成功，代表值为基本数据，直接赋值
  //       result = unzipStr
  //      }
  //    }
     return unzipStr
}
const zip = function(data) {
  if (!data) return data
    // 判断数据是否需要转为JSON
    // const dataJson = typeof data !== 'string' && typeof data !== 'number' ? JSON.stringify(data) : data
    // 使用Base64.encode处理字符编码，兼容中文
    const str = Base64.encode(data)
    let binaryString = pako.gzip(str);
    let arr = Array.from(binaryString);
    let s = "";
    arr.forEach((item, index) => {
      s += String.fromCharCode(item)
    })
    return btoa(s)
}

export {
  JSONStringify,
  JSONParse,
  unzip,
  zip
}



// WEBPACK FOOTER //
// ./src/pages/config/functions.js